module.exports = __webpack_public_path__ + "img/售电合约@2x.cd894b03.png";